import { render, staticRenderFns } from "./light.vue?vue&type=template&id=0e127d08&scoped=true&"
import script from "./light.vue?vue&type=script&lang=js&"
export * from "./light.vue?vue&type=script&lang=js&"
import style0 from "./light.vue?vue&type=style&index=0&id=0e127d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e127d08",
  null
  
)

export default component.exports